import React, { useEffect } from "react";
import styles from "./CountrySelection.module.css";
import { ConfirmationModalContext } from "../../../fautures/ConfirmationModalProvider";
import { AuthContext } from "../../../Constants/AuthProvider";
import { useFetchWithToken } from "../../FetchWithToken/FetchWithToken";
import { toast } from "react-toastify";
import { apiUrl } from "../../../Constants/Constants";

const CountrySelection = ({ details, loadingShower, getInfo, countryInfo }) => {
  const {
    openUpModal,
    description,
    confirmTitle,
    payloadConfirm,
    toDo,
    closeModal,
  } = React.useContext(ConfirmationModalContext);

  const changeUserLocationPrompt = (location, flag, id) => {
    confirmTitle("تغییر به لوکیشن " + location + " " + flag + " ؟");
    openUpModal();

    description(
      <>
        با تایید شما، لوکیشن سرویس شما به {location} تغییر خواهد کرد. برای اعمال
        برروی کلیه اپلیکیشن هایتان یکبار سرویس خود را قطع و مجدد وصل نمایید.
      </>
    );

    toDo(() => changeUserLocation);
    payloadConfirm({ id: details.id, location: id });
  };
  const changeUserLocation = ({ location, id }) => {
    const former = new FormData();
    former.append("accountid", id);
    former.append("location", location);

    fetchWithToken(
      apiUrl + "user/change-user-location",
      { method: "POST" },
      former
    ).then((data) => {
      closeModal();
      if (data.status === "200") {
        toast.success(data.data);

        getInfo();
      } else if (data.status === "6") {
        toast.error(data.data);
      }
      if (data.status === "401") {
        onLogout();
      }
    });
  };
  const { onLogout } = React.useContext(AuthContext);
  const { loading, fetchWithToken } = useFetchWithToken();
  useEffect(() => {
    loadingShower(loading);
  }, [loading]);

  const CountryShower = (country) => {
    switch (country) {
      case "UnitedStates":
        return " 🇺🇸 آمریکا";
        break;
      case "UAE":
        return "🇦🇪 امارات";
        break;
      case "Australia":
        return "🇦🇺 استرالیا";
        break;
      case "Holland":
        return "🇳🇱 هلند";
        break;
      case "UnitedKingdom":
        return "🇬🇧 انگلستان";
        break;
      case "Germany":
        return "آلمان 🇩🇪";
        break;
      case "Canada":
        return "کانادا 🇨🇦";
        break;
      case "Sweden":
        return "سوئد 🇸🇪";
        break;
      case "France":
        return "فرانسه 🇫🇷";
        break;
      case "Oman":
        return "عمان 🇴🇲";
        break;
    }
  };
  const countryPicture = (countryId) => {
    console.log(countryId);
    switch (countryId) {
      case "UnitedStates":
        return "/asets/US.svg";
        break;
      case "UAE":
        return "/asets/Emi.svg";
        break;
      case "Australia":
        return "/asets/US.svg";
        break;
      case "Holland":
        return "/asets/Nether.svg";
        break;
      case "UnitedKingdom":
        return "/asets/Eng.svg";
        break;
      case "Germany":
        return "/asets/Ger.svg";
        break;
      case "Canada":
        return "/asets/Cad.svg";
        break;
      case "Sweden":
        return "/asets/Sew.svg";
        break;
      case "France":
        return "/asets/US.svg";
        break;
      case "Oman":
        return "/asets/Omn.svg";
        break;
      case "Backup":
        return "/asets/emergency.svg";
        break;
      case "Backup2":
        return "/asets/emergency.svg";
        break;
    }
  };

  const EachCountry = ({
    countryName,
    id,
    currentLocation,
    countryFlag,
    ping,
    show,
  }) => {
    console.log(show);
    return (
      <>
        {show !== false && (
          <>
            {ping !== "undefinedms" && (
              <div
                onClick={() =>
                  changeUserLocationPrompt(countryName, countryFlag, id)
                }
                className={`${styles.eachCountry} ${
                  currentLocation == id && styles.active
                }`}
              >
                <div className={styles.flagIcon}>
                  <img src={countryPicture(id)} />
                </div>
                <div className={styles.flagtitle}>{countryName}</div>
                <div className={styles.ping}>{ping}</div>
              </div>
            )}
          </>
        )}
      </>
    );
  };
  const findProtocolByEngName = (serverId, protocols, engName) => {
    const arOnId = protocols.find((item) => item.serverId === serverId);

    const finer = arOnId.MainProtocols.find(
      (item) => item.EngProtocolName.toLowerCase() === engName.toLowerCase()
    );

    return finer?.ProtonPing + "ms";
  };

  const findBackupProtocolByEngName = (serverId, protocols, engName) => {
    const arOnId = protocols.find((item) => item.serverId === serverId);
    try {
      const finer = arOnId?.Backup.find(
        (item) => item?.EngProtocolName?.toLowerCase() === engName.toLowerCase()
      );
      return finer?.ProtonPing + "ms";
    } catch (e) {
      return false;
    }
  };

  const findBackupProtocol2ByEngName = (serverId, protocols, engName) => {
    const arOnId = protocols?.find((item) => item.serverId === serverId);

    try {
      const finer = arOnId?.Backup2.find(
        (item) => item?.EngProtocolName?.toLowerCase() === engName.toLowerCase()
      );
      return finer?.ProtonPing + "ms";
    } catch (e) {
      return false;
    }
  };

  return (
    <div className={styles.userActions}>
      {/* <div className={styles.detailitem}> */}
      <div className={`${styles.label} ${styles.fuller} `}>
        <div className={styles.mkcol2}>
          <div>
            <i class="fa-solid fa-map-location-dot"></i>
            انتخاب لوکیشن
          </div>
          {/* <div className={styles.inle}>
            <video
              width="30"
              height="40"
              controls=""
              autoplay=""
              name="media"
              autoPlay
              muted
              loop
            >
              <source src="MainScene.webm" type="video/webm" />
            </video>
            متصل
          </div> */}
          {/* <div className={styles.statusSecure}>
            {CountryShower(details.currentLocation)}
          </div> */}
        </div>
        {/* <div className={styles.downpartdesc}>
          <div className={styles.trafficde}>
            <i class="fal fa-exclamation-circle"></i>
            <div className={styles.aftertrcde}>
              بدون نیاز به دانلود کانفیگ جدید، میتوانید لوکیشن اتصال خود را
              تغییر دهید.
              <br />
              <br />
              برای امنیت بیشتر، لطفاً لوکیشن VPN خودتون رو زیاد تغییر ندین.
              تغییرات مکرر کشور ممکنه باعث بلاک شدن حساب‌هاتون در صرافی‌ها و
              سرویس‌های حساس بشه.
              <br />
              پینگ کمتر = سرعت بهتر
            </div>
          </div>
        </div> */}
      </div>
      <div className={styles.countryBox}>
        <EachCountry
          countryName="آمریکا"
          id="UnitedStates"
          currentLocation={details.currentLocation}
          countryFlag="🇺🇸"
          ping={findProtocolByEngName(
            details.serverId,
            countryInfo,
            "UsaClients"
          )}
        />
        <EachCountry
          countryName="امارات"
          id="UAE"
          currentLocation={details.currentLocation}
          countryFlag="🇦🇪"
          ping={findProtocolByEngName(
            details.serverId,
            countryInfo,
            "UaeClients"
          )}
        />
        <EachCountry
          countryName="آلمان"
          id="Germany"
          currentLocation={details.currentLocation}
          countryFlag="🇩🇪"
          ping={findProtocolByEngName(
            details.serverId,
            countryInfo,
            "GermanyClients"
          )}
        />

        <EachCountry
          countryName="اضطراری"
          id="Backup"
          currentLocation={details.currentLocation}
          countryFlag=""
          ping={findBackupProtocolByEngName(
            details.serverId,
            countryInfo,
            "Backup"
          )}
          show={findBackupProtocolByEngName(
            details.serverId,
            countryInfo,
            "Backup"
          )}
        />
        <EachCountry
          countryName="هلند"
          id="Holland"
          currentLocation={details.currentLocation}
          countryFlag="🇳🇱"
          ping={findProtocolByEngName(
            details.serverId,
            countryInfo,
            "HollandClients"
          )}
        />
        <EachCountry
          countryName="اضطراری2"
          id="Backup2"
          currentLocation={details.currentLocation}
          countryFlag=""
          ping={findBackupProtocol2ByEngName(
            details.serverId,
            countryInfo,
            "Backup2"
          )}
          show={findBackupProtocol2ByEngName(
            details.serverId,
            countryInfo,
            "Backup2"
          )}
        />

        <EachCountry
          countryName="سوئد"
          id="Sweden"
          currentLocation={details.currentLocation}
          countryFlag="🇸🇪"
          ping={findProtocolByEngName(
            details.serverId,
            countryInfo,
            "SwedenClients"
          )}
        />
        <EachCountry
          countryName="فرانسه"
          id="France"
          currentLocation={details.currentLocation}
          countryFlag="🇫🇷"
          ping={findProtocolByEngName(
            details.serverId,
            countryInfo,
            "FranceClients"
          )}
        />

        <EachCountry
          countryName="انگلستان"
          id="UnitedKingdom"
          currentLocation={details.currentLocation}
          countryFlag="🇬🇧"
          ping={findProtocolByEngName(
            details.serverId,
            countryInfo,
            "UkClients"
          )}
        />
        <EachCountry
          countryName="کانادا"
          id="Canada"
          currentLocation={details.currentLocation}
          countryFlag="🇨🇦"
          ping={findProtocolByEngName(
            details.serverId,
            countryInfo,
            "CanadaClients"
          )}
        />
        <EachCountry
          countryName="عمان"
          id="Oman"
          currentLocation={details.currentLocation}
          countryFlag="🇴🇲"
          ping={findProtocolByEngName(
            details.serverId,
            countryInfo,
            "OmanClients"
          )}
        />
      </div>
      <div className={styles.notesondesc}>
        جهت حفظ بیشتر امنیت، لطفا لوکیشن VPN خود را زیاد تغییر ندهید. تغییرات
        مکرر کشور ممکن است بلاک شدن حساب های شما در صرافی ها و سرویس های حساس را
        به دنبال داشته باشد!
      </div>
    </div>
  );
};

export default CountrySelection;
